/**
 * Post Edit Render
 * DOM rendering helpers for post edit setup flow.
 */

import commonUtil from "../../util/common-utils";
import { Roles } from "../../constants/roles";

function renderSnsLinkInputs(snsLinksList: HTMLElement | null | undefined, links: string[]): void {
    if (!(snsLinksList instanceof HTMLElement)) return;

    const items = Array.isArray(links) ? links : [];
    snsLinksList.innerHTML = "";
    if (items.length === 0) return;

    const html = items
        .map((linkUrl, index) => {
            const safeIndex = commonUtil.escapeHtmlAttribute(String(index));
            const safeValue = commonUtil.escapeHtmlAttribute(String(linkUrl || ""));
            return `
                <div class="sns-link-item" data-role="${Roles.SNS_LINK_ITEM}" data-index="${safeIndex}">
                    <input type="text" name="sns_links[]" class="textbox sns-link-input" data-role="${Roles.SNS_LINK_INPUT}" value="${safeValue}" placeholder="https://...">
                </div>
            `;
        })
        .join("");

    snsLinksList.insertAdjacentHTML("beforeend", html);
}

export { renderSnsLinkInputs };
